import { get, post } from 'edrolo/domains/net';
import urlResolver from 'edrolo/utils/URLResolver';

export const loadLessonByLessonId = async (lessonId, isDemo) => {
  const url = urlResolver.reverse(
    isDemo ? 'api:demo-lesson-detail' : 'api:application-lesson-detail',
    {
      lessonId,
    }
  );
  return get(url);
};

export const loadChunkVisitsByLessonId = async (lessonId) => {
  const url = urlResolver.reverse('api:lesson-chunk-visits', { lessonId });
  return get(url);
};

export const recordChunkVisit = async (chunkId) => {
  const url = urlResolver.reverse('api:chunk-visit', { id: chunkId });
  return post(url);
};

export const loadQuizAttemptsByLessonId = async (lessonId) => {
  // API call - get from /api/v1/lessons/:id/responses/
  const url = urlResolver.reverse('api:lesson-responses-detail', {
    lessonId,
  });
  return get(url);
};

export const saveQuizAttempt = async (quizAttempt) => {
  const url = urlResolver.reverse('ajax:evaluate-answer');
  return post(url, quizAttempt);
};

export const loadQuizStatsByLessonId = async (lessonId) => {
  const url = urlResolver.reverse('api:lesson-quiz-stats', { id: lessonId });
  return get(url);
};

// API endpoint calls for success measure responses
export const loadSuccessMeasureResponsesByLessonId = async (lessonId) => {
  const url = urlResolver.reverse('api:lesson-success-measure-responses', {
    lessonId,
  });
  return get(url);
};

export const recordSuccessMeasureResponse = async (successMeasureId, value) => {
  const payload = {
    success_measure_id: successMeasureId,
    value: value,
  };
  const url = urlResolver.reverse('api:record-success-measure-response');
  return post(url, payload);
};
